// @scripts
import { DEFAULT_WIDTH_COLUMN } from './config/helpers';

// @styles
import globals from '../../../../styles/globals';

const headerDefault = { whiteSpace: 'normal' };
export default (theme) => ({
    ...globals(theme),
    rowPanel: {
        minHeight: 400
    },
    table: {
        marginBottom: 15,
        marginTop: 15,
        '& .ui-iggrid-headertext': {
            ...headerDefault
        },
        '& .ui-iggrid-colheaderdesc .ui-iggrid-headertext': {
            ...headerDefault
        },
        '& .ui-iggrid-headercell-featureenabled .ui-iggrid-headertext': {
            ...headerDefault
        },
        '& .ui-iggrid-childarea .ui-iggrid tbody>tr>td:first-child': {
            // The use of '!important' is not recommended, however it is used, given the restriction of the JCI CDN styles
            background: '#ffffff !important',
            borderWidth: '0px !important'
        },
        '& .ui-iggrid-modaldialog-caption-buttoncontainer': {
            fontSize: 12
        },
        '& .ui-dialog .ui-dialog-content': {
            height: 400
        }
    },
    hiddenExpandColumnWithoutGrouping: {
        // The use of '!important' is not recommended, however it is used,
        // given the restriction of the IgGrid column 'col' width.
        '& colgroup col:first-child, tbody tr td:first-child, thead tr th:first-child, thead tr td:first-child': {
            width: '0px !important'
        },
        '& .ui-iggrid-childarea tbody tr td:first-child, .ui-iggrid-childarea thead tr th:first-child': {
            width: `${DEFAULT_WIDTH_COLUMN}px !important`
        },
        '& .ui-iggrid-childarea thead tr td:first-child': {
            width: `${DEFAULT_WIDTH_COLUMN}px !important`
        }
    },
    hiddenExpandColumnWithGrouping: {
        // The use of '!important' is not recommended, however it is used,
        // given the restriction of the IgGrid column 'col' width.
        '& colgroup col:nth-child(2), tbody tr td:nth-child(2), thead tr th:nth-child(2), thead tr td:nth-child(2)': {
            width: '0px !important'
        },
        '& .ui-iggrid-childarea tbody tr td:nth-child(2), .ui-iggrid-childarea thead tr th:nth-child(2)': {
            width: `${DEFAULT_WIDTH_COLUMN}px !important`
        },
        '& .ui-iggrid-childarea thead tr td:nth-child(2)': {
            width: `${DEFAULT_WIDTH_COLUMN}px !important`
        }
    }
});
